var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.allowed)?_vm._t("default"):(!_vm.toggle)?_vm._t("fallback",[_c('access-denied')]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }